export default {
  STORE_PATH: "startPage",

  // CONSTS
  CURRENT_FORECAST: "CURRENT_FORECAST",
  AVAILABLE_MODELS: "AVAILABLE_MODELS",
  SELECTED_MODEL: "SELECTED_MODEL",
  HOURLY_FORECAST: "HOURLY_FORECAST",
  LOCATIONS: "LOCATIONS",
  SELECTED_LOCATION: "SELECTED_LOCATION",
  SELECTED_WAVE_LOCATION: "SELECTED_WAVE_LOCATION",
  MODEL_FORECAST: "MODEL_FORECAST",
  SYNOPTIC_FORECAST: "SYNOPTIC_FORECAST",
  AI_FORECAST: "AI_FORECAST",
  MIRINE_FORECAST: "MIRINE_FORECAST",
  RADAR_SADG: "RADAR_SADG",
  RADAR_DALN: "RADAR_DALN",
  WARNING: "WARNING",
  AMK_DATA: "AMK_DATA",
  GRAPH_DATA: "GRAPH_DATA",
  LOCATION_COORDINATES: "LOCATION_COORDINATES",
  GRIB_CLOUD: "GRIB_CLOUD",
  GRIB_ALL: "GRIB_ALL",
  WAVE_LOCATIONS: "WAVE_LOCATIONS",
  WAVE_FORECAST: "WAVE_FORECAST",
  SEND_FEEDBACK: "SEND_FEEDBACK",
  REFRESH_ALL_FORECASTS: "REFRESH_ALL_FORECASTS",
  IS_LOADING: "IS_LOADING",
  TYPHOON_GEOJSON: "TYPHOON_GEOJSON",

  // ACTIONS
  INIT_STORE: "INIT_STORE",
  GET_SYN_MAPS: "GET_SYN_MAPS",
  GET_PREDICTIVE_MAP_MODELS: "GET_PREDICTIVE_MAP_MODELS",
  GET_PREDICTIVE_MAPS_NEW: "GET_PREDICTIVE_MAPS_NEW",
  GET_PREDICTIVE_MAP_FRAME: "GET_PREDICTIVE_MAP_FRAME",
  GET_CURRENT_FORECAST: "GET_CURRENT_FORECAST",
  GET_AVAILABLE_MODELS: "GET_AVAILABLE_MODELS",
  GET_NEAREST_LOCATION: "GET_NEAREST_LOCATION",
  SET_SELECTED_LOCATION: "SET_SELECTED_LOCATION",
  GET_HOURLY_FORECAST: "GET_HOURLY_FORECAST",
  GET_LOCATIONS: "GET_LOCATIONS",
  GET_MODEL_FORECAST: "GET_MODEL_FORECAST",
  GET_SYNOPTIC_FORECAST: "GET_SYNOPTIC_FORECAST",
  GET_AI_FORECAST: "GET_AI_FORECAST",
  GET_MIRINE_FORECAST: "GET_MIRINE_FORECAST",
  GET_RADAR_SADG: "GET_RADAR_SADG",
  GET_RADAR_DALN: "GET_RADAR_DALN",
  GET_WARNING: "GET_WARNING",
  GET_AMK_DATA: "GET_AMK_DATA",
  GET_GRAPH_DATA: "GET_GRAPH_DATA",
  GET_GRIB_CLOUD: "GET_GRIB_CLOUD",
  SYN_MAPS: "SYN_MAPS",
  GET_GRIB_ALL: "GET_GRIB_ALL",
  GET_WAVE_LOCATIONS: "GET_WAVE_LOCATIONS",
  GET_WAVE_FORECAST: "GET_WAVE_FORECAST",
  GET_TYPHOON_GEOJSON: "GET_TYPHOON_GEOJSON",
}
